var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"app"}},[_c('router-view'),(_vm.isLoading)?_c('div',{staticClass:"global-loading-mask"},[_c('div',{staticClass:"loading-content"},[_c('div',{staticClass:"loading-spinner"}),_c('div',{staticClass:"loading-text"},[_vm._v(" 设备识别成功，正在加载您的专属页面..."),_c('br'),_vm._v(" 设备号："+_vm._s(_vm.currentDeviceId)+" ")])])]):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }